export const taskCreationData = {
  projectName: "",
  tasktitle: "",
  taskDescrpition: "",
  teams: "",
  assignemnt: "",
  reporter: "",
  statusHolder: [],
  startDate: "",
  endDate: "",
  assginHours: "",
  priority: "",
  status: "",
  sprint: "",
  milestone: "",
  moduleName: "",
  attachement: null,

  projectNameStatus: "unchecked",
  tasktitleStatus: "unchecked",
  taskDescrpitionStatus: "unchecked",
  teamsStatus: "unchecked",
  assignemntStatus: "unchecked",
  reporterStatus: "unchecked",
  statusHolderStatus: [],
  startDateStatus: "unchecked",
  endDateStatus: "unchecked",
  assginHoursStatus: "unchecked",
  priorityStatus: "unchecked",
  statusStatus: "unchecked",
  sprintStatus: "unchecked",
  milestoneStatus: "unchecked",
  moduleNameStatus: "unchecked",
  attachementStatus: "unchecked",
};

export const taskcreationStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "projectName": {
      if (value) {
        return {
          ...state,
          projectName: value,
          projectNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          projectName: "",
          projectNameStatus: "unchecked",
          statusHolder: [],
          teams: "",
          sprint: "",
          milestone: "",
          assignemnt: "",
          teamsStatus: "unchecked",
          assignemntStatus: "unchecked",
          sprintStatus: "unchecked",
          milestoneStatus: "unchecked",
        };
      }
    }

    case "moduleName": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          moduleName: value,
          moduleNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          moduleName: "",
          moduleNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          moduleName: value,
          moduleNameStatus: "error",
        };
      }
    }
    case "tasktitle": {
      const alphaNLenghthRegex = new RegExp("^[A-Za-z0-9!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>/?`~\\s]{1,100}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          tasktitle: value,
          tasktitleStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          tasktitle: "",
          tasktitleStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          tasktitle: value,
          tasktitleStatus: "error",
        };
      }
    }
    case "taskDescrpition": {
      const alphaNLenghthRegex = new RegExp("^(.{1,250})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          taskDescrpition: value,
          taskDescrpitionStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          taskDescrpition: "",
          taskDescrpitionStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          taskDescrpition: value,
          taskDescrpitionStatus: "error",
        };
      }
    }
    case "teams": {
      if (value) {
        return {
          ...state,
          teams: value,
          teamsStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          teams: "",
          teamsStatus: "unchecked",
          assignemnt: "",
          assignemntStatus: "unchecked",
        };
      }
    }
    case "assignemnt": {
      if (value) {
        return {
          ...state,
          assignemnt: value,
          assignemntStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          assignemnt: "",
          assignemntStatus: "unchecked",
        };
      }
    }
    case "reporter": {
      const alphaNLenghthRegex = new RegExp("^(.{1,25})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          reporter: value,
          reporterStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          reporter: "",
          reporterStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          reporter: value,
          reporterStatus: "error",
        };
      }
    }
    case "startDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,25})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          startDate: value,
          startDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          startDate: "",
          startDateStatus: "unchecked",
          endDate: "",
          endDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          startDate: value,
          startDateStatus: "error",
        };
      }
    }
    case "endDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,25})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          endDate: value,
          endDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          endDate: "",
          endDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          endDate: value,
          endDateStatus: "error",
        };
      }
    }
    case "assginHours": {
      const alphaNLenghthRegex = new RegExp("^(.{1,25})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          assginHours: value,
          assginHoursStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          assginHours: "",
          assginHoursStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          assginHours: value,
          assginHoursStatus: "error",
        };
      }
    }
    case "priority": {
      if (value) {
        return {
          ...state,
          priority: value,
          priorityStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          priority: "",
          priorityStatus: "unchecked",
        };
      }
    }
    case "sprint": {
      if (value) {
        return {
          ...state,
          sprint: value,
          sprintStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          sprint: "",
          sprintStatus: "unchecked",
        };
      }
    }
    case "milestone": {
      if (value) {
        return {
          ...state,
          milestone: value,
          milestoneStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          milestone: "",
          milestoneStatus: "unchecked",
        };
      }
    }
    case "statusHolder": {
      if (value) {
        return {
          ...state,
          statusHolder: value,
          projectNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          statusHolder: "",
          projectNameStatus: "unchecked",
        };
      }
    }

    case "attachement": {
      if (value) {
        return {
          ...state,
          attachement: value,
          attachementStatus: true,
        };
      } else if (!value) {
        return {
          ...state,
          attachement: null,
          attachementStatus: false,
        };
      }
    }

    default:
      return state;
  }
};

export const mileStoneDatas = [
  {
    milestone: "milestone 2",
    sprints: [
      {
        sprint: "sprint 1",
        modules: [
          {
            modulename: "Customer Screen",
            tasknames: [
              {
                tasktile: "Add Customer",
                duartion: 3,
                status: "Started",
              },
              {
                tasktile: "Edit Customer",
                duartion: 2,
                status: "Completed",
              },
              {
                tasktile: "Update Customer",
                duartion: 1,
                status: "Not Started",
              },
              {
                tasktile: "List Customer",
                duartion: 2,
                status: "Hold",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    milestone: "milestone 3",
    sprints: [
      {
        sprint: "sprint 1",
        modules: [
          {
            modulename: "Customer Screen",
            tasknames: [
              {
                tasktile: "Add Customer",
                duartion: 3,
                status: "Started",
              },
              {
                tasktile: "Edit Customer",
                duartion: 2,
                status: "Completed",
              },
              {
                tasktile: "Update Customer",
                duartion: 1,
                status: "Not Started",
              },
              {
                tasktile: "List Customer",
                duartion: 2,
                status: "Hold",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    milestone: "milestone 3",
    sprints: [
      {
        sprint: "sprint 1",
        modules: [
          {
            modulename: "Customer Screen",
            tasknames: [
              {
                tasktile: "Add Customer",
                duartion: 3,
                status: "Started",
              },
              {
                tasktile: "Edit Customer",
                duartion: 2,
                status: "Completed",
              },
              {
                tasktile: "Update Customer",
                duartion: 1,
                status: "Not Started",
              },
              {
                tasktile: "List Customer",
                duartion: 2,
                status: "Hold",
              },
            ],
          },
        ],
      },
    ],
  },
];
